<template>
  <el-dialog
    :title="$t('storeOrderLogistics.logisticsInfo')"
    :visible.sync="dialogVisible"
    width="50%"
  >
    <div class="express-container">
      <el-row v-for="(item, index) in showStoreOrderExpressInfo.express" :key="index" class="express-item">
        <el-col :span="6">
          <label>{{ item.time }}：</label>
        </el-col>
        <el-col :span="18">
          <label>{{ item.context }}</label>
        </el-col>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('storeOrderLogistics.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryLogisticsDetail } from '@/api/order/storeOrderLogisticsApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ShowStoreOrderExpress',
  data() {
    return {
      dialogVisible: false,
      showStoreOrderExpressInfo: {
        orderId: '',
        express: []
      }
    }
  },
  methods: {
    open(order) {
      this.clear()
      this.showStoreOrderExpressInfo.orderId = order.orderId
      this._loadStoreOrderExpress()
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
    },
    clear() {
      this.showStoreOrderExpressInfo = {
        orderId: '',
        express: []
      }
    },
    async _loadStoreOrderExpress() {
      try {
        const params = {
          page: 1,
          row: 100,
          orderId: this.showStoreOrderExpressInfo.orderId,
          shopId: getShopId()
        }
        const res = await queryLogisticsDetail(params)
        this.showStoreOrderExpressInfo.express = res.data
      } catch (error) {
        console.error('请求物流详情失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.express-container {
  padding: 10px;
}
.express-item {
  margin-bottom: 10px;
}
</style>